import { HStack } from '@chakra-ui/react';
import { SuggestionsButton } from '~/components/ui/tabs/Button';
import { SuggestionsButtonList } from '~/components/ui/tabs/ButtonList';
import { SuggestionBackButton } from '~/components/ui/tabs/components/BackButton';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';

const LIVING_SPACE_RANGES = [
  { label: '0 - 50 m²', min: 0, max: 50 },
  { label: '50 - 75 m²', min: 50, max: 75 },
  { label: '75 - 100 m²', min: 75, max: 100 },
  { label: '100 - 150 m²', min: 100, max: 150 },
  { label: '150 - 200 m²', min: 150, max: 200 },
  { label: '200+ m²', min: 200, max: null },
];

export const LivingSpaceRangeTabContent = () => {
  const filters = useHomesStore((state) => state.filters);
  const { living_space_min, living_space_max } = filters || {};
  const { performSearch } = useFilters();

  const isActive = (range: { min: number; max: number | null }) => {
    return living_space_min === range.min && living_space_max === range.max;
  };

  const onSelectRange = (range: { min: number; max: number | null }) => {
    if (isActive(range)) {
      performSearch({
        filters: { living_space_min: undefined, living_space_max: undefined },
      });
    } else {
      performSearch({
        filters: {
          living_space_min: range.min || undefined,
          living_space_max: range.max || undefined,
        },
      });
    }
  };

  return (
    <HStack mb={1} alignItems="center" overflowX="hidden">
      <SuggestionBackButton filterKeysToRemove={['rooms_min', 'rooms_max']} />
      <SuggestionsButtonList>
        {LIVING_SPACE_RANGES.map((range, index) => (
          <SuggestionsButton
            key={index}
            label={range.label}
            isActive={isActive(range)}
            onClick={() => onSelectRange(range)}
          />
        ))}
      </SuggestionsButtonList>
    </HStack>
  );
};
